import Route from 'cio/routes/base';
import { inject as service } from '@ember/service';
import Transition from '@ember/routing/-private/transition';
import AccountService from 'cio/services/account';
import UserModel from 'cio/models/user';
import NewController from 'cio/pods/settings/personal/security/new/controller';

export default class NewRoute extends Route {
  @service account!: AccountService;

  crumb() {
    return {
      name: 'Two-factor authentication setup',
      path: this.routeName,
    };
  }

  async model() {
    let account = this.account.current;
    let user = account.belongsTo('currentUser').value() as UserModel | null;

    return {
      user,
      codes: await user?.generateNewTwoFactorAuthenticationBackupCodes(),
    };
  }

  setupController(
    controller: NewController,
    model: { user: UserModel | null; codes?: string[] },
    transition: Transition,
  ) {
    super.setupController(controller, model, transition);
    controller.setProperties({
      canFinish: false,
      serverErrors: [],
    });
  }
}
